import type { JSX } from 'react';
export type SpacerProperties = {
  horizontal?: boolean;
  vertical?: boolean;
  size: number | string;
  margin?: number;
  className?: string;
};

export const Spacer = ({
  vertical,
  size,
  margin = 0,
  className,
}: SpacerProperties): JSX.Element => (
  <div
    className={className}
    css={
      vertical !== undefined && vertical
        ? {
            margin: `${margin}px 0`,
            width: '100%',
            minHeight: size,
            height: size,
          }
        : {
            margin: `0 ${margin}px`,
            height: '100%',
            width: size,
            minWidth: size,
          }
    }
  />
);
